import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { getPointsRuleAttention, type PointsRuleOwner } from '@/entities/expert-report';
import { toastWarning } from '@/shared/lib';

/**
 * Предупреждение о правиле расчёта после сохранения, изменившего состав или названия вложенных
 * блоков: правило ссылается на вложенные блоки по названиям и само за ними не меняется.
 *
 * Предупреждают о том же, о чём говорит отметка в дереве: правило владельца требует внимания —
 * стало неприменимым либо считает результат не по всему составу вложенных блоков. Владельцев берут
 * из ответа сервера, поэтому правка, вернувшая состав и названия к ожидаемому правилом виду,
 * предупреждения не даёт. Сохранение предупреждение не отменяет.
 */
export const usePointsRuleChangeWarning = () => {
  const { t } = useTranslation('expertReport');

  return useCallback(
    (owners: (PointsRuleOwner | null | undefined)[]) => {
      const names = Array.from(
        new Set(owners.flatMap((owner) => (owner && getPointsRuleAttention(owner) ? [owner.name] : []))),
      );
      if (!names.length) return;
      toastWarning(t('pointsRuleCheckNeeded'), {
        // Название блока или заключения читается как введено: кавычки в нём — знаки, а не разметка
        description: t('pointsRuleCheckNeededDescription', {
          blockNames: names.join(', '),
          interpolation: { escapeValue: false },
        }),
      });
    },
    [t],
  );
};
